import { Injectable } from '@angular/core'
import flatpickr, * as Flatpickr from 'flatpickr'

@Injectable()
export class FlatpickrFactory {
  create(element: any, config: Partial<Flatpickr.default.Options.Options>): Flatpickr.default.Instance {
    return flatpickr(element, config)
  }
}
